import React, { useState, useEffect } from 'react';
import { Grid, Typography, Link, Modal } from '@mui/material/';
import { useStyles } from '../../../assets/jss/components/Modal/HomeLoadingScreen/homeLoadingScreenStyles';
import { useTheme } from '@mui/material/styles';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import GetHelpModal from '../../../containers/Modal/getHelpModalContainer';

export default function HomeLoadingScreen(props) {
  const classes = useStyles(props);
  const {
    // Props
    isSignUp,
    // States
    percentage,
    userEmail,
    open,
    percentageLoadingScreen,
    valueTab,
    loadingHandler,
    loadingStudyModes,
    fromcourseHome,
    generateStripePaymentError
  } = props;
  const theme = useTheme();
  const [openGetHelpModal, setOpenGetHelpModal] = useState(false);
  const [progressbar, setProgressBar] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (open) {
      if (progressbar < 100) setProgressBar(percentageLoadingScreen);
    }
  }, [open, percentageLoadingScreen, progressbar]);

  useEffect(() => {
    if (!open) setOpenModal(false);
  }, [open]);

  useEffect(() => {
    if (open && valueTab === 0) {
      if (loadingStudyModes || loadingHandler > 0) setOpenModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingStudyModes, loadingHandler, valueTab, open]);

  useEffect(() => {
    if (progressbar === 100) {
      // after 0.5 seconds set loading screen to false to see the 100% progress bar
      setTimeout(() => {
        setOpenModal(false);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progressbar]);

  useEffect(() => {
    if (progressbar === 100 || percentageLoadingScreen === 100) {
      setProgressBar(100);
      //after 0.5 seconds set loading screen to false to see the 100% progress bar
      setTimeout(() => {
        setOpenModal(false);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progressbar, percentageLoadingScreen]);

  useEffect(() => {
    setProgressBar(percentage);
  }, [percentage]);

  const shouldShowLoader = () => {
    let should = fromcourseHome ? openModal : open;
    if (should == null) return false;
    else return should;
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={shouldShowLoader()}
      closeAfterTransition={false}
      hideBackdrop={true}
    >
      <Grid container className={classes.root}>
        <div className={classes.paper}>
          <CircularProgressbarWithChildren
            value={fromcourseHome ? progressbar : percentageLoadingScreen}
            className={classes.loaderStyles}
            strokeWidth={3}
            styles={buildStyles({
              rotation: 0,
              strokeLinecap: 'butt',
              pathTransitionDuration: 0.5,
              pathColor: theme.palette.primary.main,
              trailColor: theme.palette.divider,
              backgroundColor: theme.palette.primary.graycolor
            })}
          >
            <Grid className={classes.textDiv}>
              <Typography className={classes.textValue}>{`${
                fromcourseHome ? progressbar : percentageLoadingScreen
              }%`}</Typography>
            </Grid>
          </CircularProgressbarWithChildren>
          {generateStripePaymentError ? (
            <Typography className={classes.errorMsg}>{generateStripePaymentError}</Typography>
          ) : (
            <Typography className={classes.subtitleStyles}>
              {isSignUp
                ? 'We are generating the link for payment...'
                : 'One moment while we load your course...'}
            </Typography>
          )}
          {isSignUp && !generateStripePaymentError ? null : (
            <Grid className={classes.textContainer}>
              <Typography className={classes.textStyles}>
                Technical Difficulties?{' '}
                <u>
                  <Link className={classes.contactUsLink} onClick={() => setOpenGetHelpModal(true)}>
                    Contact Us
                  </Link>
                </u>
              </Typography>
            </Grid>
          )}
        </div>
        {openGetHelpModal && (
          <GetHelpModal
            open={openGetHelpModal}
            handleOnClose={() => setOpenGetHelpModal(false)}
            source={isSignUp ? 4 : 1}
            userEmail={userEmail}
            preselectedIssue={
              isSignUp
                ? { type: 'OTHER', label: 'Other' }
                : { type: 'TECHNICAL_ISSUE', label: 'Technical issue' }
            }
          />
        )}
      </Grid>
    </Modal>
  );
}
